import { Request } from '../api/axiosConfig';

export const APIService = {
    validateApplicationData: (params) => Request.post('ApplicationsRegistry/VerifyApplicationData', params),
    finishApplication: (params) => Request.post('ApplicationsRegistry/FinishApplication', params),
    cancleApplication: (params) => Request.post('ApplicationsRegistry/CancleApplication', params)
};